import { FC, useEffect } from 'react'
import { useLocation } from 'react-router'
import { DrawerComponent } from '../assets/components/DrawerComponent'
import { WithChildren } from '../models';

/**
 * Wrapper del contenido de pagina. Oculta los Drawers al navegar entre rutas.
 */
const Content: FC<WithChildren> = ({children}) => {
  const location = useLocation()
  useEffect(() => {
    DrawerComponent.hideAll()
  }, [location])

  return (
    <div id='kt_content_container' className="px-5 mx-5 w-100">
      {children}
    </div>
  )
}

export {Content}
